import styled from 'styled-components';
import { MapContainer } from 'react-leaflet';

export const MapContainerStyled = styled(MapContainer)`
	height: 100%;
	width: 100%;

	img.leaflet-div-icon {
		background-color: transparent !important;
		border-width: 0 !important;
	}
	.leaflet-bottom {
		display: none !important;
	}
`;

export const NavigatorContainerStyled = styled(MapContainer)`
	height: 100%;
	width: 100%;
	z-index: 0;

	img.leaflet-div-icon {
		background-color: transparent !important;
		border-width: 0 !important;
	}
	.leaflet-bottom {
		display: none !important;
	}
`;

export const MapContainerSmall = styled(MapContainer)`
	height: 400px;
	width: 60%;

	img.leaflet-div-icon {
		background-color: transparent !important;
		border-width: 0 !important;
	}
`;
